import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import LocationMarker from './EventsHandler';
import UpdateMap from './Update';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import L from 'leaflet';
import { useState } from 'react';

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
});



const Map = ({ height, location, callBack }) => {
  const [map, setMap] = useState(null);
  if(!location || location[0]==null || location[1]==null || location[0]=='' || location[1]==''){
    location=[29.620207, 51.652271];
  }
  return (
    <div
      className={`w-full h-40 relative`}
      style={{ zIndex: '5', height: height || '' }}
    >
      <MapContainer
        center={location ? location : [29.620207, 51.652271]}
        zoom={15}
        scrollWheelZoom={false}
        ref={setMap}
      >
        <TileLayer
          className="z-10"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {map && callBack && (
          <>
            <LocationMarker map={map} location={location} callBack={callBack} />
            <UpdateMap map={map} location={[29.620207, 51.652271]} />
          </>
        )}
        {map && location && (
          <>
            <Marker position={location} icon={DefaultIcon} />
            <UpdateMap map={map} location={location} />
          </>
        )}
      </MapContainer>
    </div>
  );
};

export default Map;
